import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { NgHttpLoaderModule } from 'ng-http-loader';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { acceptInterceptor } from './core/http/interceptors/accept.interceptor';
import { errorHandlerInterceptor } from './core/http/interceptors/error-handler.interceptor';
import { CoolStorageModule } from '@angular-cool/storage';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        // anchorScrolling: 'enabled', // Haremos el scroll manualmente en category-page
      }),
    ),
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptors([acceptInterceptor, errorHandlerInterceptor]),
      withInterceptorsFromDi(),
    ),
    importProvidersFrom(NgHttpLoaderModule.forRoot(), CoolStorageModule.forRoot()),
  ],
};
